import GamificationLeaderboard from "../../components/gamification-leaderboard.gjs";

export default <template>
  <GamificationLeaderboard @model={{@controller.model}} />
</template>
